import css from '!raw-loader!@/assets/styles/default.css'
import VueCompositionAPI, { computed, reactive } from '@vue/composition-api'
import Vue from 'vue'
Vue.use(VueCompositionAPI)

const state = reactive({
	css,
	html: '',
	markdown: '',
	status: {
		error: '',
		loading: false,
	},
})

const getCss = computed(() => state.css)
const getMarkdown = computed(() => state.markdown)
const getHtml = computed(() => state.html)
const getError = computed(() => state.status.error)
const getLoading = computed(() => state.status.loading)

const setHtml = ({ html }) => {
	state.html = html
}

const setLoading = status => {
	state.status.loading = status
}

const seterror = message => {
	state.status.error = message
}

const loadHtml = async ({ html }) => {
	setLoading(true)
	try {
		const res = await fetch('../../../api/generate', {
			method: 'POST',
			body: `content=${JSON.stringify(html)}`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		})
		setHtml({ html: await res.text() })
		setLoading(false)
	} catch (error) {
		seterror(error.message)
		setLoading(false)
	}
}

const editorState = {
	getCss,
	getError,
	getHtml: computed(() => getHtml),
	getLoading,
	getMarkdown,
	loadHtml,
}

export default editorState
